import gql from "graphql-tag";

const QUERY = gql`
	query getReadReceiptRateCard(
		$userId: String!,
		$platform: Platform!,
		$productType: ProductType!,
		$productSubtype: ProductSubType!,
	) {
		user(id: $userId) {
			id
			rateCard(
				platform: $platform
				productType: $productType
				productSubtype: $productSubtype
			) {
					productPriceInfoList {
						countryCode
						subPeriodType
						formattedInitialUnitPrice
						formattedInitialSubtotalPrice
						formattedInitialSubtotalPriceBase
						productType
						initialTaxes {
							taxType
							billingTaxRatesUSId
							billingStateCode
							billingCountryCode
							amount
							formattedAmount
						}
						initialCurrency
						subPeriod
						productSubType
						productId
						formattedInitialPrice
						tokensCount
						initialUnitPrice
					}
			}
		}
	}
`;

export default QUERY;



// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/queries.js